@use '../../../scss/utility/functions' as utility;

:host {
  --padding-inline-start: 0px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding-inline-start: var(--padding-inline-start);
  width: calc(var(--grey-box-action-size) + var(--padding-inline-start));
}

:host(:not(:first-of-type)) {
  --padding-inline-start: var(--grey-box-action-gap);
}

::slotted(.wb-spinner) {
  --size: var(--grey-box-action-icon-size);
}
